import SignupSection from "./signupSection";
import DownloadSection from "./downloadSection";
import ReactGA from "react-ga";
import TopBar from "../../components/TopBar";
import VerticalGap from "../../components/VerticalGap";

import "./index.scss";

const NewStartHere = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div>
      <TopBar
        heading="How it works!"
        description="Getting started on your fitness journey is as easy as a few simple steps. With a short sign up process and a quick download on your mobile device, you'll have our trainers by your side at every turn!"
      />
      <SignupSection />
      <VerticalGap />
      <DownloadSection />
    </div>
  );
};

export default NewStartHere;
